import { render } from "./CustomNumberFromFilter.vue?vue&type=template&id=465dcaea&scoped=true"
import script from "./CustomNumberFromFilter.vue?vue&type=script&lang=js"
export * from "./CustomNumberFromFilter.vue?vue&type=script&lang=js"

import "./CustomNumberFromFilter.vue?vue&type=style&index=0&id=465dcaea&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465dcaea"]])

export default __exports__